import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biMessageBoxCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.MessageBox-container{display:flex;flex-direction:row;align-items:center;gap:16px;padding:16px;border-radius:4px;font-size:1.5rem;line-height:1.5;color:black}.MessageBox-container.error{background-color:#fff2f2;color:#8c0a08}.MessageBox-container.success{background-color:honeydew;color:#05630a}.MessageBox-container.info{background-color:#f2f9fc;color:#01417b}.MessageBox-container.warning{background-color:#fff7e3}.MessageBox-container .text-container{display:flex;flex-direction:column;gap:4px}.MessageBox-container .heading{font-size:1rem;font-weight:600}.MessageBox-container .message{font-size:1rem}";
const BiMessageBoxStyle0 = biMessageBoxCss;

const MessageBox = /*@__PURE__*/ proxyCustomElement(class MessageBox extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.variant = 'error';
    }
    getIcon() {
        switch (this.variant) {
            case 'success':
                return 'bi-icon-checkmark';
            case 'info':
                return 'bi-icon-information';
            case 'error':
            case 'warning':
                return 'bi-icon-error';
            default:
                return 'bi-icon-warning';
        }
    }
    render() {
        const Icon = this.getIcon();
        return (h(Host, { key: '84daa74104618b859944bcebbf317bcc690a7d91' }, h("div", { key: 'a4abb8fbfc5dd9ef31931b180cecbc105411702a', class: classNames(`MessageBox-container`, this.variant) }, h("slot", { key: 'ae1f0a77a49172fcdc4f3701e0b75dfda24592af', name: 'icon' }, h(Icon, { key: '35788e3d4db3cf6393f0ffa01de61ac7810af16c', "aria-hidden": 'true' })), h("div", { key: '8a6509b63de2d618899f9bebbf097c536958c260', class: 'text-container' }, this.heading && h("p", { key: '82ac7e591cab5aa708bd6f7bc6bec04ab455e33a', class: 'heading' }, this.heading), h("p", { key: '1675bc03660660266e05770e4ffa8fa8a3c58ec0', class: 'message' }, h("slot", { key: 'd300f2084d59b86b7bea69ff5834ae12d63a2a4a' }, this.message))))));
    }
    static get style() { return BiMessageBoxStyle0; }
}, [1, "bi-message-box", {
        "heading": [1],
        "message": [1],
        "variant": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-message-box"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-message-box":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MessageBox);
            }
            break;
    } });
}

const BiMessageBox = MessageBox;
const defineCustomElement = defineCustomElement$1;

export { BiMessageBox, defineCustomElement };
